import { useQuery } from '@tanstack/react-query';
import { api } from '../../config';

export interface Machine {
  id: number;
  machineIdHash: string;
  displayId: string;
  firstSeen: string;
  lastSeen: string;
  totalUpdateChecks: number;
  totalDownloads: number;
  lastVersion?: string;
  platform?: string;
  architecture?: string;
  osVersion?: string;
  appVersion?: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface MachineInfo {
  machine: Machine;
  activations: Array<{
    activationId: string;
    licenseId: string;
    licenseKey: string;
    status: string;
    createdAt: string;
  }>;
  updateHistory: Array<{
    id: number;
    eventType: string;
    releaseId?: number;
    fromVersion?: string;
    toVersion?: string;
    success: boolean;
    errorCode?: string;
    errorMessage?: string;
    timestamp: string;
  }>;
  downloadHistory: Array<{
    id: number;
    releaseId: number;
    startedAt: string;
    completedAt?: string;
    bytesDownloaded?: number;
    errorCode?: string;
  }>;
}

export function useMachine(machineId: string) {
  return useQuery<MachineInfo>({
    queryKey: ['machine', machineId],
    queryFn: async () => {
      return await api.get<MachineInfo>(`/api/v1/updates/admin/machines/${machineId}`);
    },
    enabled: !!machineId,
  });
}